import React, { useState, useEffect, createContext } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { AuthContext, AuthProvider } from "./AuthContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Settings from "./pages/Settings";
import SettingsAdjust from "./pages/SettingsAdjust";
import Register from "./pages/Register";
import AddTipos from "./pages/AddTipos";
import AddTables from "./pages/AddTables";
import TableItems from "./pages/TableItems";
import AddEventos from "./pages/AddEventos";
import EditUser from "./pages/EditUser";
import Families from "./pages/Families";
import Products from "./pages/Products";
import ListProducts from "./pages/ListProducts";
import AddClients from "./pages/AddClients";
import ListClients from "./pages/ListClients";
import AddCotacao from './pages/AddCotacao';
import ListCotacoes from './pages/ListCotacoes';
import ViewQuote from './pages/ViewQuote';
import ChangePassword from "./pages/ChanPasswd";
import ProtectedRoute from "./components/ProtectedRoute";
import Navbar from "./components/Navbar";
import { AnimatePresence, motion } from "framer-motion";
import "./App.css";
import { loadConfig } from "./components/Constants";

export const ThemeContext = createContext(); // ✅ contexto do tema

function AnimatedRoutes() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = React.useContext(AuthContext);
  

  useEffect(() => {
    if (user && location.pathname === "/") {
      navigate("/dashboard");
    } else if (!user && location.pathname === "/dashboard") {
      navigate("/");
    }
    loadConfig(user?.token); // Carrega as configurações ao iniciar o app
  }, [user, location.pathname, navigate]);

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.2 }}
      >
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="/settingsadjust" element={<ProtectedRoute><SettingsAdjust /></ProtectedRoute>} />
          <Route path="/chanpasswd" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
          <Route path="/addtables" element={<ProtectedRoute><AddTables /></ProtectedRoute>} />
          <Route path="/tableitems" element={<ProtectedRoute><AddTables /></ProtectedRoute>} />
          <Route path="/tableitems/:id" element={<ProtectedRoute><TableItems /></ProtectedRoute>} />
          <Route path="/addtipos" element={<ProtectedRoute><AddTipos /></ProtectedRoute>} />
          <Route path="/addeventos" element={<ProtectedRoute><AddEventos /></ProtectedRoute>} />
          <Route path="/families" element={<ProtectedRoute><Families /></ProtectedRoute>} />
          <Route path="/products" element={<ProtectedRoute><Products /></ProtectedRoute>} />
          <Route path="/listproducts" element={<ProtectedRoute><ListProducts /></ProtectedRoute>} />
          <Route path="/addclients" element={<ProtectedRoute><AddClients /></ProtectedRoute>} />
          <Route path="/addclients/:id" element={<ProtectedRoute><AddClients /></ProtectedRoute>} />
          <Route path="/listclients" element={<ProtectedRoute><ListClients /></ProtectedRoute>} />
          <Route path="/listclients/:id" element={<ProtectedRoute><ListClients /></ProtectedRoute>} />
          <Route path="/edituser/:id" element={<ProtectedRoute><EditUser /></ProtectedRoute>} />
          <Route path="/addcotacao" element={<ProtectedRoute><AddCotacao/></ProtectedRoute>} />
          <Route path="/listcotacoes" element={<ProtectedRoute><ListCotacoes/></ProtectedRoute>} />
          <Route path="/viewquote" element={<ProtectedRoute><ViewQuote/></ProtectedRoute>} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}

function AppContent() {
  const { user } = React.useContext(AuthContext);
  const location = useLocation();

  const showNavbar = user && !["/"].includes(location.pathname);

  return (
    <>
      {showNavbar && <Navbar />}
      <AnimatedRoutes />
    </>
  );
}

export default function App() {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

  useEffect(() => {
    document.body.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => setTheme(theme === "light" ? "dark" : "light");

  return (
    <AuthProvider>
      <ThemeContext.Provider value={{ theme, toggleTheme }}>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </ThemeContext.Provider>
    </AuthProvider>
  );
}
